import React, { useState } from "react";
import "./faqPage.css";
import Nav from "../../components/nav/Nav";
import { Button, Group, Text, Collapse, Box } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { ReactComponent as CaretIcon } from "../../assets/CaretDown.svg";
import { ReactComponent as SmallCrossIcon } from "../../assets/fi-rr-cross-small.svg";
import Contact from "../../components/contact/Contact";
import Footer from "../../components/footer/Footer";

export const CustomFaq = ({ content, title }) => {
  const [opened, { toggle }] = useDisclosure(false);
  return (
    <div className="faq-wrapper">
      <div
        onClick={toggle}
        style={{
          width: "100%",
          cursor: "pointer",

          display: "flex",
          justifyContent: "space-between",
          gap: "20px",
          alignItems: "center",
        }}
      >
        <p className="faq-item-text">{title}</p>

        <span className="caret-icon-wrapper">
          <CaretIcon />
        </span>
      </div>
      <Collapse in={opened}>
        <p className="sub-header" style={{ color: "#565A6D" }}>
          {content}
        </p>
      </Collapse>
    </div>
  );
};

const FaqPage = () => {
  const [data] = useState([
    {
      text: "How much does it cost to file a claim?",
      content:
        "Nothing upfront. Fly n' Claim operates on a No Win, No Fee basis. If we don’t win your case, you pay nothing.",
    },
    {
      text: "How long does the process take?",
      content:
        "Most claims are processed within 4 to 12 weeks, depending on the airline and the case complexity.",
    },
    {
      text: "What documents do I need to file a claim?",
      content:
        "At minimum: flight details, boarding pass (or e-ticket), and personal ID. Additional documents like baggage receipts or correspondence with the airline may be helpful.",
    },
    {
      text: "Am I eligible for compensation if my flight was delayed due to weather?",
      content:
        "Likely not. Weather delays are considered extraordinary circumstances and usually exempt airlines from paying compensation under EU261.",
    },
    {
      text: "Can I file a claim for multiple passengers on the same booking?",
      content:
        "Yes. You can include multiple passengers during the claim process. Each eligible passenger may be entitled to separate compensation.",
    },
  ]);
  const [data2] = useState([
    {
      text: "What is a disrupted flight?",
      content:
        "A disrupted flight includes delays, cancellations, denied boarding due to overbooking, or missed connections that significantly affect your travel.",
    },
    {
      text: "How do I know if I am entitled to flight compensation?",
      content:
        "Use our quick eligibility checker online. We evaluate your case based on applicable regulations like EU261, Montreal Convention, or US DOT.",
    },
    {
      text: "How long does a flight need to be delayed to qualify for compensation?",
      content:
        "Under EU261, a delay must be 3+ hours upon arrival to qualify for compensation.",
    },
    {
      text: "How much compensation can I expect for a delayed or cancelled flight?",
      content:
        "Depending on distance and delay length, you may be entitled to €250–€600 under EU261. For international flights and baggage issues, Montreal Convention may cover up to €1,200.",
    },
    {
      text: "When can you claim compensation for flight delays?",
      content:
        "If the delay was 3+ hours, not caused by extraordinary circumstances (like weather or political unrest), and occurred within the legal time window (up to 3 years in most countries).",
    },
  ]);
  const [data3] = useState([
    {
      text: "What if the airline refuses to pay compensation?",
      content:
        "We will continue the process, including escalation to legal channels if needed, at no additional cost to you.",
    },
    {
      text: "My claim has already been rejected by the airlines. Can I still use Fly n’ Claim services?",
      content:
        "Yes. We often succeed with claims previously rejected by airlines.",
    },
    {
      text: "I completed the claim form and received the answer that my flight compensation claim will not be pursued. What can I do next?",
      content:
        "If your case is outside the scope of legal eligibility, there may be no grounds to pursue it. However, you're welcome to contact our team for a manual review.",
    },
    {
      text: "How long does the compensation recovery process take?",
      content:
        "While many claims are resolved in weeks, some may take longer if legal steps or appeals are needed. We'll keep you updated throughout.",
    },
    {
      text: "Can you help with compensation for lost baggage?",
      content:
        "Yes. Under the Montreal Convention, you may be entitled to reimbursement for expenses or loss up to €1,200. We’ll guide you through the process.",
    },
  ]);
  const [data4] = useState([
    {
      text: "How much does the bank transfer cost?",
      content:
        "Bank transfers are free in most cases. If applicable, any transfer fees will be clearly stated before payout.",
    },
    {
      text: "How will I get my money for the compensated flight?",
      content:
        "Compensation is transferred directly to your bank account or preferred method, after deduction of our service fee.",
    },
    {
      text: "In what currency will I receive my money?",
      content:
        "You’ll be paid in your local currency or the airline’s payout currency. We will clarify this before finalizing the transfer.",
    },
    {
      text: "What fees does Fly n’ Claim charge if the airline rejects my flight compensation claim?",
      content: "None. You only pay if we successfully recover compensation.",
    },
    {
      text: "How much do Fly n’ Claim services cost?",
      content:
        "Our fee is a percentage of the total compensation received, clearly communicated before you confirm your claim. If we don’t win, you pay nothing.",
    },
  ]);
  const [userInput, setUserInput] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [selectedQuestion, setSelectedQuestion] = useState(null);
  const [filteredData, setFilteredData] = useState(data);
  const [filteredData2, setFilteredData2] = useState(data2);
  const [filteredData3, setFilteredData3] = useState(data3);
  const [filteredData4, setFilteredData4] = useState(data4);

  const handleUserInput = (e) => {
    const input = e.target.value;
    setUserInput(input);
    const lowInput = input.toLowerCase();

    if (input.length > 0) {
      const sugg = [...data, ...data2, ...data3, ...data4].filter((item) =>
        item.text.toLowerCase().includes(lowInput)
      );
      // console.log(sugg);

      setSuggestions(sugg);
    } else {
      setSuggestions([]);
    }
  };

  const handleSearch = (searchText) => {
    setSelectedQuestion(null);
    if (!searchText.trim()) {
      setFilteredData(data);
      setFilteredData2(data2);
      setFilteredData3(data3);
      setFilteredData4(data4);
    } else {
      setFilteredData(
        data.filter((item) =>
          item.text.toLowerCase().includes(searchText.toLowerCase())
        )
      );
      setFilteredData2(
        data2.filter((item) =>
          item.text.toLowerCase().includes(searchText.toLowerCase())
        )
      );
      setFilteredData3(
        data3.filter((item) =>
          item.text.toLowerCase().includes(searchText.toLowerCase())
        )
      );
      setFilteredData4(
        data4.filter((item) =>
          item.text.toLowerCase().includes(searchText.toLowerCase())
        )
      );
      setSuggestions([]);
    }
  };

  const handleCross = () => {
    setSelectedQuestion(null);
    setUserInput("");
    setSuggestions([]);
    setFilteredData(data);
    setFilteredData2(data2);
    setFilteredData3(data3);
    setFilteredData4(data4);
  };

  const handleSuggestionClick = (suggestion) => {
    setUserInput(suggestion);
    setSuggestions([]);
    setSelectedQuestion(suggestion);
    setFilteredData(data.filter((item) => item.text === suggestion));
    setFilteredData2(data2.filter((item) => item.text === suggestion));
    setFilteredData3(data3.filter((item) => item.text === suggestion));
    setFilteredData4(data4.filter((item) => item.text === suggestion));
  };

  return (
    <div>
      <Nav />
      <div style={{ marginTop: "50px" }}>
        <div className="faq-page-wrapper">
          <div className="faq-text-wrapper">
            <h3 className="header">Frequently asked questions</h3>

            <div className="faq-search">
              <div className="faq-btn">
                <input
                  className="faq-input"
                  type="text"
                  placeholder="i.e. Can I book a trip anywhere in the world?"
                  value={userInput}
                  onChange={(e) => handleUserInput(e)}
                />
                {userInput && <SmallCrossIcon onClick={() => handleCross()} />}
                <button onClick={() => handleSearch(userInput)}>SEARCH</button>
              </div>
              {suggestions.length > 0 && (
                <div className="faq-search-suggestions">
                  {suggestions.map((item, idx) => (
                    <div
                      key={idx}
                      onClick={() => handleSuggestionClick(item.text)}
                    >
                      <p>{item.text}</p>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          {filteredData.length > 0 && (
            <div className="faq-items-wrapper">
              <h2 className="faq-header">
                Top questions regarding flight compensation
              </h2>
              <div style={{ marginTop: "10px" }}>
                <div style={{ marginTop: "10px" }}>
                  {filteredData.map((item, index) => (
                    <CustomFaq
                      key={index}
                      title={item.text}
                      content={item.content}
                    />
                  ))}
                </div>
              </div>
            </div>
          )}

          {filteredData2.length > 0 && (
            <div className="faq-items-wrapper">
              <h2 className="faq-header">
                General information about delayed, cancelled, or overbooked
                flights
              </h2>
              <div style={{ marginTop: "10px" }}>
                {filteredData2.map((item, index) => (
                  <CustomFaq
                    key={index}
                    title={item.text}
                    content={item.content}
                  />
                ))}
              </div>
            </div>
          )}

          {filteredData3.length > 0 && (
            <div className="faq-items-wrapper">
              <h2 className="faq-header">How Fly n’ Claim works</h2>
              <div style={{ marginTop: "10px" }}>
                {filteredData3.map((item, index) => (
                  <CustomFaq
                    key={index}
                    title={item.text}
                    content={item.content}
                  />
                ))}
              </div>
            </div>
          )}

          {filteredData4.length > 0 && (
            <div className="faq-items-wrapper" style={{ borderBottom: "0px" }}>
              <h2 className="faq-header">
                Payment of flight compensation and taxes
              </h2>
              <div style={{ marginTop: "10px" }}>
                {filteredData4.map((item, index) => (
                  <CustomFaq
                    key={index}
                    title={item.text}
                    content={item.content}
                  />
                ))}
              </div>
            </div>
          )}
        </div>
        <Contact />
        <Footer />
      </div>
    </div>
  );
};

export default FaqPage;
